import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import moment from 'moment';

import { Course } from '../../../shared/models/course';
import { UserService } from './../../../../shared/services/user.service';
import { ViewStateService } from './../../../../shared/services/view-state.service';
import { PractitionerService } from './../../../shared/services/practitioner.service';

import { debounceTime, takeUntil } from "rxjs/operators";

@Component({
  selector: 'app-update-course',
  templateUrl: './update-course.component.html'
})
export class UpdateCourseComponent implements OnInit, OnDestroy {
  personId: string;
  courseId: number;
  existingCourse: Course = {} as Course;
  course$ = new BehaviorSubject<Course>(this.existingCourse);
  onDestroy$ = new Subject();
  constructor(private practitionerService: PractitionerService, private viewState: ViewStateService,
    private route: ActivatedRoute, private userService: UserService) {
  }

  ngOnInit() {
    this.viewState.startLoading();
    this.personId = this.userService.CurrentUser.personId;
    this.courseId = this.route.snapshot.params["id"];
    this.getCourse()
  }

  private getCourse() {
    this.practitionerService.courseCompletions(this.personId)
    .pipe(takeUntil(this.onDestroy$))
    .subscribe(result => {
        this.existingCourse = (<Course[]>result).find(c => c.id == this.courseId);
        this.course$.next(this.existingCourse);
    });
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
